<template>
	<div class="index6">
		<header @click="onlink()">
			<h1 style="padding-top: 30px;"><span>三电健康监测</span></h1>
			<!-- <p><span>Triboelectric health monitoring</span></p> -->
		</header>

		<div class="main">
			<div class="top5">
				<div class="top5-title">
					<span style="font-size: 0.7rem;">vin码 {{form1.vin}}</span>
				</div>
				<div class="top5-content">
					<ul>
						<li><span>{{form1.carType}}</span><span>车型</span></li>
						<li><span>{{form1.batType}}</span><span>电池类型</span></li>
						<li><span>{{form1.ratedCapacity}}<b>Ah</b></span><span>额定容量</span></li>
						<li><span>{{form1.ratedVoltage}}<b>v</b></span><span>额定电压</span></li>
						<li><span>{{form1.SOCB}}<b>%</b></span><span>起始容量SOC</span></li>
						<li><span>{{form1.singleMaxTemp}}<b>℃</b></span><span>单体最高温度</span></li>
						<li><span>{{form1.currentSoc}}<b>%</b></span><span>当前容量SOC</span></li>
						<li><span>{{form1.singleMinTemp}}<b>℃</b></span><span>单体最低温度</span></li>
						<li><span>{{form1.singleMaxVoltage}}<b>v</b></span><span>单体最高电压</span></li>
						<router-link v-if="form1.historyRecordNum" :to="{path:'/testRecord',query:{vin:form1.vin}}">
							<li>
								<span>{{form1.historyRecordNum}}</span>
								<span style="color: #0ac1c7;">历史检测记录</span>
							</li>
						</router-link>
					</ul>
				</div>
				<div class="top5-title">
					<span>单体温度 </span>
				</div>

			</div>
			<!-- 健康指标 -->
			<div class="total">
				<div class="data1">
					<span>容量特性SOH</span>
					<p>{{form2.capacityMetrics}}%</p>
				</div>
				<div class="data2">
					<span>温度特性SOT</span>
					<p>{{form2.sot}}%</p>
				</div>
				<div class="data3">
					<span>能量特性SOE</span>
					<p>{{form2.energyIndicator}}%</p>
				</div>
				<div class="data4">
					<span>一致性</span>
					<p>{{form2.consistency}}%</p>
				</div>
				<canvas class="rain"></canvas>
				<canvas class="dashed"></canvas>
				<div class="sphere">
					<div class="sphere-bg"></div>
					<div class="sum">
						<p>{{form2.score}}<span>检测得分</span></p>
					</div>
					<img class="carimg" src="../assets/images/car3.png">
				</div>
				<div class="cicle3"></div>
				<div class="cicle4"></div>
				<div class="cicle5"></div>
				<div class="cicle6"></div>
				<div class="cicle7"></div>
				<div :class="form2.thermalRunaway!='0'?'cicle8':'cicle8 cicleBlue'">
					<span :class="form2.thermalRunaway!='0'?'much':' '">
						{{onThermalRunaway(form2.thermalRunaway)}}</span>
					<p>热失控</p>
				</div>
				<div :class="form2.cooling!='0'?'cicle9':'cicle9 cicleBlue'">
					<span :class="form2.cooling!='0'?'much':''">{{onCooling(form2.cooling)}}</span>
					<p>冷却系统</p>
				</div>
				<div :class="form2.seal!='0'?'cicle10':'cicle10 cicleBlue'">
					<span :class="form2.seal!='0'?'much':''">{{onCooling(form2.seal)}}</span>
					<p>气密性</p>
				</div>
				<!-- <div class="cicle11">
					<span>-</span>
					<p>气密性</p>
				</div> -->
			</div>
			<!-- 异常指标 -->
			<div class="analyse">
				<div class="analyse-title">
					<span>异常指标</span>
				</div>
				<ul>
					<li><span
							:class="form3.singleVoltageStatus=='正常'?'':'unusual'">单体电压</span><em>{{form3.singleVoltageStatus}}</em>
					</li>
					<li><span :class="form3.socStatus=='正常'?'':'unusual'">SOC荷电</span><em>{{form3.socStatus}}</em></li>
					<li><span
							:class="form3.electricityStatus=='正常'?'':'unusual'">充电过电流</span><em>{{form3.electricityStatus}}</em>
					</li>
					<li><span :class="form3.tempStatus=='正常'?'':'unusual'">温度状态</span><em>{{form3.tempStatus}}</em></li>
					<li><span
							:class="form3.batteryInsulation=='正常'?'':'unusual'">绝缘状态</span><em>{{form3.batteryInsulation}}</em>
					</li>
					<li><span
							:class="form3.insulationStatus=='正常'?'':'unusual'">输出连接器连接</span><em>{{form3.insulationStatus}}</em>
					</li>
					<li><span
							:class="form3.bmsStopChargeFault=='正常'?'':'unusual'">BMS终止充电故障</span><em>{{form3.bmsStopChargeFault}}</em>
					</li>
					<li><span
							:class="form3.bmsStopChargeError=='正常'?'':'unusual'">BMS终止充电错误</span><em>{{form3.bmsStopChargeError}}</em>
					</li>
					<li><span :class="form3.socAlarm=='正常'?'':'unusual'">SOC跳变</span><em>{{form3.socAlarm}}</em></li>
					<li><span
							:class="form3.tempDiffAlarm=='正常'?'':'unusual'">最大温差</span><em>{{form3.tempDiffAlarm}}</em>
					</li>
					<li><span
							:class="form3.tempRiseAlarm=='正常'?'':'unusual'">最高温度变化率</span><em>{{form3.tempRiseAlarm}}</em>
					</li>
					<li><span
							:class="form3.maxAllowableVoltageAlarm=='正常'?'':'unusual'">需求电压</span><em>{{form3.maxAllowableVoltageAlarm}}</em>
					</li>
					<li><span
							:class="form3.maxAllowableElectricityAlarm=='正常'?'':'unusual'">需求电流</span><em>{{form3.maxAllowableElectricityAlarm}}</em>
					</li>

				</ul>
			</div>
			<!-- 单体电压 -->
			<div class="lineChart2"></div>

			<!-- 单体温度 -->
			<div class="lineChart"></div>
		</div>

		<div class="bottom">
			<h5><span>{{form1.lastUpdateTime}}</span></h5>
			<p>最新检测时间</p>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				w: 0,
				RainDrop: null,

				form1: {},
				form2: {
					thermalRunaway: '',
					cooling: '',
					seal: '',
				},
				form3: {},
				tempchart: null,
				tempchart2: null,
				pileCode: '',
				recordCode: '',
			}
		},
		mounted() {
			let _this = this;
			var query = this.$route.query;
			_this.pileCode = query.pileCode;
			_this.recordCode = query.recordCode;
			this.$nextTick(() => {
				setTimeout(function() {
					_this.placeholderPic()
					_this.dashed()
					_this.onSingle()
					_this.onDynamicData();
					_this.onSingleTempList();
					_this.onSingleVoltageList();
				}, 500);
			})
			window.addEventListener("resize", function() {
				_this.placeholderPic()
				_this.dashed()
			});
		},
		methods: {

			onDynamicData: function() {
				let _this = this;
				this.$api.post('/order/dynamic/data', {
						pileCode: _this.pileCode == undefined ? '' : _this.pileCode, //充检桩编号
						recordCode: _this.recordCode == undefined ? '' : _this.recordCode, //订单编号
					},
					function(response, context) {
						if (response.code == "200") {
							let data = response.data;

							// $(".sphere img").addClass("carimg");

							_this.form1 = data.baseInfo;
							_this.form2 = data.evaluationInfo;
							_this.form3 = data.alarmTarget == undefined ? {} : data.alarmTarget;


							if (_this.form2.score == undefined) {
								_this.form2.score = 0;
							}

							if (_this.form2.consistency == undefined) {
								_this.form2.consistency = 0;
							}

							if (_this.websock != null) {
								_this.websocketclose();
							}
							if (data.pileInfo && data.pileInfo.orderStatus == '2') {
								_this.recordCode = data.pileInfo.recordCode;
								_this.initWebSocket();
							}



						} else {
							_this.$message({
								showClose: true,
								message: "列表：" + response.message,
								type: response.code == "200" ? 'success' : 'error'
							});
						}
					}
				);
			},
			onSingleTempList: function() {
				let _this = this;
				this.$api.post('/order/dynamic/data/single/temp', {
						pileCode: _this.pileCode == undefined ? '' : _this.pileCode, //充检桩编号
						recordCode: _this.recordCode == undefined ? '' : _this.recordCode, //订单编号
					},
					function(response, context) {
						if (response.code == '200') {
							_this.singleTempInfoList = response.data;
							_this.onSingle(response.data, "temp");
						}

					})
			},
			onSingleVoltageList: function() {
				let _this = this;
				this.$api.post('/order/dynamic/data/single/voltage', {
						pileCode: _this.pileCode == undefined ? '' : _this.pileCode, //充检桩编号
						recordCode: _this.recordCode == undefined ? '' : _this.recordCode, //订单编号
					},
					function(response, context) {
						if (response.code == '200') {
							_this.singleVoltageInfoList = response.data;
							_this.onSingle(response.data, "voltage");
						}
					})
			},
			onSingle: function(list, str) {
				let _this = this;
				let singleMaxTemp = [],
					singleMinTemp = [],
					maxTempPointNum = [],
					minTempPointNum = [],
					tempRange = [],
					singleMaxVoltage = [],
					singleMinVoltage = [],
					maxSingleVoltageGroupNum = [],
					maxSingleVoltageNum = [],
					voltageRange = [],
					dateTime = [];
				if (list == undefined) return;
				for (let item of list) {
					if (item[0].length >= 18) {
						let str1 = item[0].substring(11, 19);
						let str2 = item[0].substring(5, 10);
						dateTime.push(str1 + "\n" + str2);
					} else {
						dateTime.push(item[0]);
					}

					if (str == 'temp') {
						singleMaxTemp.push(item[1]);
						singleMinTemp.push(item[2]);
						maxTempPointNum.push(item[3]);
						minTempPointNum.push(item[4]);
					} else {
						singleMaxVoltage.push(item[1]);
						singleMinVoltage.push(item[2]);
						maxSingleVoltageGroupNum.push(item[3]);
						maxSingleVoltageNum.push(item[4]);
					}
				}
				setTimeout(function() {
					if (str == 'temp') {
						_this.maxTempList = singleMaxTemp;
						_this.minTempList = singleMinTemp;
						_this.tempRangeList = tempRange;
						_this.tempTimeList = dateTime;
						_this.maxTempPointNumList = maxTempPointNum;
						_this.minTempPointNumList = minTempPointNum;

						_this.onTemperature();
					} else {
						_this.maxVoltageList = singleMaxVoltage;
						_this.minVoltageList = singleMinVoltage;
						_this.voltageRangeList = voltageRange;
						_this.voltageTimeList = dateTime;
						_this.maxSingleVoltageGroupNumList = maxSingleVoltageGroupNum;
						_this.maxSingleVoltageNumList = maxSingleVoltageNum;

						_this.onVoltage();
					}
				}, 2000)
			},

			initWebSocket: function() {
				const wsuri = this.$api.WebSocket + "/ws/dynamic_" + this.recordCode;

				this.websock = new WebSocket(wsuri);
				this.websock.onmessage = this.websocketonmessage;
				this.websock.onopen = this.websocketonopen;
				this.websock.onerror = this.websocketonerror;
				this.websock.onclose = this.websocketclose;
			},
			websocketonopen: function() {
				console.log('websocket链接成功');
			},
			websocketonerror: function() {
				console.log('连接建立失败重连');
			},
			websocketonmessage: function(e) {
				let _this = this;
				const redata = JSON.parse(e.data);
				switch (redata.key) {
					case "data_alarm":
						_this.alarmData.unshift(redata.value);
						break;
					case "data_base_info":
						_this.form1 = Object.assign({}, _this.form1, redata.value);
						_this.onechartsData(redata.value);
						break;
					case "data_assess_report":
						let item = redata.value;
						if (item.thermalRunaway == '1') {
							item.thermalRunaway = '一级告警';
						} else if (item.thermalRunaway == '2') {
							item.thermalRunaway = '二级告警';
						} else if (item.thermalRunaway == '3') {
							item.thermalRunaway = '三级告警';
						} else {
							item.thermalRunaway = '正常';
						}

						if (item.cooling == '1') {
							item.cooling = '疑似故障';
						} else if (item.cooling == '2') {
							item.cooling = '故障';
						} else {
							item.cooling = '正常';
						}

						if (item.seal == '1') {
							item.seal = '疑似故障';
						} else if (item.seal == '2') {
							item.seal = '故障';
						} else {
							item.seal = '正常';
						}

						_this.form2 = item;

						break;
					default:
						break;
				}
			},

			placeholderPic: function() {
				this.w = document.documentElement.clientWidth / 80;
				document.documentElement.style.fontSize = this.w + 'px';
			},
			draw: function(ele, val, con, max, color) {
				var chart = this.$echarts.init(document.querySelector(ele))
				var value = val
				let option = {
					grid: {
						left: '20%',
						top: '0',
						right: '20%',
						bottom: '0'
					},
					"xAxis": {
						type: 'value',
						"splitLine": {
							"show": false
						},
						"axisLine": {
							"show": false
						},
						"axisLabel": {
							"show": false
						},
						"axisTick": {
							"show": false
						}
					},
					"yAxis": [{
						"type": "category",
						"inverse": false,
						"data": [],
						"axisLine": {
							"show": false
						},
						"axisTick": {
							"show": false
						},
						"axisLabel": {
							show: false
						}
					}],
					"series": [{
							type: 'pictorialBar',
							data: [value],
							itemStyle: {
								color: color
							},
							symbolRepeat: 'fixed',
							symbolClip: true,
							symbolSize: [0.5 * this.ww, this.ww],
							symbol: 'roundRect',
							label: {
								show: true,
								position: 'left',
								formatter: function() {
									return con
								},
								color: '#fff',
								fontSize: 0.7 * this.ww,
							},
							z: 1000
						},
						{
							type: 'pictorialBar',
							itemStyle: {
								color: '#193040'
							},
							data: [max],
							animationDuration: 0,
							symbolRepeat: 'fixed',
							// symbolMargin: '20%',
							symbol: 'roundRect',
							symbolSize: [0.5 * this.ww, this.ww],
							label: {
								show: true,
								position: 'right',
								formatter: function() {
									return Math.floor(val * 100 / max) + '%'
								},
								color: '#fff',
								fontSize: 0.7 * this.ww,
							}
						}
					]
				};
				chart.setOption(option)
			},
			//温度
			onTemperature: function() {
				let _this = this;
				_this.tempchart2 = this.$echarts.init(document.querySelector('.lineChart2'));

				var xdata = [];
				var dataArr = [];
				for (var i = 1; i < 30; i++) {
					xdata.push(i);
					dataArr.push(Math.floor(Math.random() * 20 + 5))
				}
				var max = Math.max.apply(null, dataArr);

				var seriesName = '';
				let option = {
					legend: {
						icon: 'rect',
						itemWidth: 14,
						itemHeight: 5,
						itemGap: 10,
						data: ['最高温度', '最低温度'],
						right: '10px',
						top: '0px',
						textStyle: {
							fontSize: 12,
							color: '#fff'
						}
					},
					grid: {
						left: "5%",
						bottom: "5%",
						top: "15%",
						containLabel: true
					},
					xAxis: {
						type: "category",
						data: _this.tempTimeList, // xdata,
						axisLabel: {
							show: true,
							color: "#fff",
							fontSize: 0.5 * this.ww,
							padding: 5,
							formatter: function(value, index) {
								var date = new Date(1000 * value);
								var texts = [date.getFullYear(), (date.getMonth() + 1), date
									.getDate()
								];
								var time = [date.getHours(), date.getMinutes(), date.getSeconds()];
								return time.join(':') //+ '\n' + texts.join('-');
							}
						},
						axisLine: {
							lineStyle: {
								color: 'transparent',
								width: 2 //这里是为了突出显示加上的
							}
						},
					},
					tooltip: {
						show: true,
						trigger: 'axis',
						axisPointer: {
							type: 'none',
						},
						formatter: function(params) {
							let timestr = new Date(1000 * params[0].axisValue);
							let texts = [timestr.getFullYear(), (timestr.getMonth() + 1), timestr
								.getDate()
							];
							var time = [timestr.getHours(), timestr.getMinutes(), timestr.getSeconds()];
							let str = texts.join('-') + " " + time.join(':') + "<br />";

							for (let data of params) {
								str += data.marker + data.seriesName + " : " + data.value + "<br />";
							}
							return str;
						}
					},
					yAxis: [{
						type: 'value',
						axisLabel: {
							formatter: '{value}',
							color: '#fff',
							fontSize: 0.5 * this.ww
						},
						axisLine: {
							lineStyle: {
								color: 'transparent',
								width: 2 //这里是为了突出显示加上的
							}
						},
						axisTick: {
							show: false,
						},
						splitLine: {
							show: false
						},
						scale: true,
					}],
					series: [{
						name: '最高温度',
						type: 'line',
						symbol: 'none',
						smooth: false,
						symbol: "circle",
						itemStyle: {
							color: '#34a39a',
							lineStyle: {
								color: "#34a39a",
								width: 2
							},
							areaStyle: {
								color: this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
										offset: 0,
										color: "#08808b"
									},
									{
										offset: 1,
										color: 'rgba(0,0,0,0.2)',
									}
								])

							}
						},
						data: _this.maxTempList, // dataArr
					}, {
						name: '最低温度',
						type: 'line',
						symbol: 'none',
						smooth: false,
						symbol: "circle",
						itemStyle: {
							color: '#f29701',
							lineStyle: {
								color: "#f29701",
								width: 2
							},
							areaStyle: {
								color: this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
										offset: 0,
										color: "#f29701"
									},
									{
										offset: 1,
										color: 'rgba(0,0,0,0.2)',
									}
								])

							}
						},
						data: _this.minTempList, // dataArr
					}, ]
				};

				var index = 0; //播放所在下标
				// var mTime = setInterval(function() {
				// 	_this.tempchart2.dispatchAction({
				// 		type: 'showTip',
				// 		seriesIndex: 0,
				// 		dataIndex: index
				// 	});
				// 	index++;
				// 	if (index > xdata.length) {
				// 		index = 0;
				// 	}
				// }, 1500);


				_this.tempchart2.setOption(option, true)
				window.addEventListener("resize", function() {
					_this.tempchart2.resize();
				});
			},
			// 电压
			onVoltage: function() {
				let _this = this;
				_this.tempchart = this.$echarts.init(document.querySelector('.lineChart'));

				var xdata = [];
				var dataArr = [];
				for (var i = 1; i < 30; i++) {
					xdata.push(i);
					dataArr.push(Math.floor(Math.random() * 20 + 5))
				}
				var max = Math.max.apply(null, dataArr);

				var seriesName = '最高电压';
				let option = {
					legend: {
						icon: 'rect',
						itemWidth: 14,
						itemHeight: 5,
						itemGap: 10,
						data: ['最高电压'], //, '最低电压'
						right: '10px',
						top: '0px',
						textStyle: {
							fontSize: 12,
							color: '#fff'
						}
					},
					grid: {
						left: "5%",
						bottom: "5%",
						top: "15%",
						containLabel: true
					},
					xAxis: {
						type: "category",
						data: _this.voltageTimeList, // xdata,
						axisLabel: {
							show: true,
							color: "#fff",
							fontSize: 0.5 * this.ww,
							padding: 5,
							formatter: function(value, index) {
								var date = new Date(1000 * value);
								var texts = [date.getFullYear(), (date.getMonth() + 1), date
									.getDate()
								];
								var time = [date.getHours(), date.getMinutes(), date.getSeconds()];
								return time.join(':') //+ '\n' + texts.join('-');

							}
						},
						axisLine: {
							lineStyle: {
								color: 'transparent',
								width: 2 //这里是为了突出显示加上的
							}
						}
					},
					tooltip: {
						show: true,
						trigger: 'axis',
						axisPointer: {
							type: 'none',
						},
						formatter: function(params) {
							let data = params[0];

							let timestr = new Date(1000 * data.axisValue);

							let texts = [timestr.getFullYear(), (timestr.getMonth() + 1), timestr.getDate()];

							var time = [timestr.getHours(), timestr.getMinutes(), timestr.getSeconds()];

							let str = texts.join('-') + " " + time.join(':') + "<br />" +
								data.marker + data.seriesName + " : " + data.value + "<br />" +
								data.marker + data.seriesName + '编号 : ' + _this.maxSingleVoltageNumList[data
									.dataIndex] + "<br />" +
								data.marker + data.seriesName + '组号 : ' + _this.maxSingleVoltageNumList[data
									.dataIndex];
							return str
						}
					},
					yAxis: [{
						type: 'value',
						axisLabel: {
							formatter: '{value}',
							color: '#fff',
							fontSize: 0.5 * this.ww
						},
						axisLine: {
							lineStyle: {
								color: 'transparent',
								width: 2
							}
						},
						axisTick: {
							show: false,
						},
						splitLine: {
							show: false
						},
						scale: true,
					}],
					series: [{
						name: seriesName,
						type: 'line',
						symbol: 'none',
						smooth: false,
						symbol: "circle",
						itemStyle: {
							color: '#34a39a',
							lineStyle: {
								color: "#34a39a",
								width: 2
							},
							areaStyle: {
								color: this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
										offset: 0,
										color: "#08808b"
									},
									{
										offset: 1,
										color: 'rgba(0,0,0,0.2)',
									}
								])

							}
						},
						data: _this.maxVoltageList, // dataArr
					}, ]
				};

				var index = 0; //播放所在下标
				// var mTime = setInterval(function() {
				// 	_this.tempchart.dispatchAction({
				// 		type: 'showTip',
				// 		seriesIndex: 0,
				// 		dataIndex: index
				// 	});
				// 	index++;
				// 	if (index > xdata.length) {
				// 		index = 0;
				// 	}
				// }, 1500);

				_this.tempchart.setOption(option, true)
				window.addEventListener("resize", function() {
					_this.tempchart.resize();
				});
			},
			// 中间虚线
			dashed: function() {
				var canvas = document.querySelector('.dashed')
				var ctx = canvas.getContext('2d')
				var w = canvas.width = document.querySelector('.total').clientWidth
				var h = canvas.height = document.querySelector('.total').clientHeight / 3 * 2
				ctx.lineWidth = 3
				ctx.setLineDash([3, 3]);
				ctx.fillStyle = '#93f8fb'
				ctx.shadowOffsetX = 0;
				// 阴影的y偏移
				ctx.shadowOffsetY = 0;
				// 阴影颜色
				ctx.shadowColor = '#93f8fb';
				// 阴影的模糊半径
				ctx.shadowBlur = 15;
				ctx.save() //缓存初始状态
				// 绘制第一条曲线
				ctx.beginPath()
				var grd = ctx.createLinearGradient(w / 11 * 2, h / 3, w / 5 * 2, h);
				grd.addColorStop(0, "#54e2e6");
				grd.addColorStop(1, "#065261");
				ctx.strokeStyle = grd;
				ctx.moveTo(w / 5 * 2, h)
				ctx.quadraticCurveTo(w / 5, h / 6 * 5, w / 11 * 2, h / 3);
				ctx.stroke();
				// 绘制第一条曲线上的圆光效果
				ctx.beginPath()
				ctx.moveTo(w / 11 * 2, h / 3)
				ctx.arc(w / 11 * 2, h / 3, 5, 0, Math.PI * 2)
				ctx.fill()
				ctx.restore()
				ctx.save()
				// 绘制第二条线
				ctx.beginPath()
				var grd = ctx.createLinearGradient(w / 11 * 3.3, h / 2, w / 3 * 1.1, h / 6 * 5);
				grd.addColorStop(0, "#e08d03");
				grd.addColorStop(1, "#2e6a5c");
				ctx.strokeStyle = grd;
				ctx.moveTo(w / 3 * 1.1, h / 6 * 5)
				ctx.quadraticCurveTo(w / 5 * 1.5, h / 6 * 4.2, w / 11 * 3.3, h / 2);
				ctx.stroke();
				// 绘制第二条曲线上的圆光效果
				ctx.beginPath()
				ctx.moveTo(w / 11 * 3.3, h / 2)
				ctx.arc(w / 11 * 3.3, h / 2, 5, 0, Math.PI * 2)
				ctx.fill()
				ctx.restore()
				ctx.save()
				// 绘制第三条线
				ctx.beginPath()
				var grd = ctx.createLinearGradient(w / 3 * 1.4, h / 5, w / 5 * 2, h / 2);
				grd.addColorStop(0, "#e08d03");
				grd.addColorStop(1, "#2e6a5c");
				ctx.strokeStyle = grd;
				ctx.moveTo(w / 5 * 2, h / 2)
				ctx.quadraticCurveTo(w / 3 * 1.2, h / 4 * 1.4, w / 3 * 1.4, h / 5);
				ctx.stroke();
				// 绘制第三条曲线上的圆光效果
				ctx.beginPath()
				ctx.moveTo(w / 3 * 1.4, h / 5)
				ctx.arc(w / 3 * 1.4, h / 5, 5, 0, Math.PI * 2)
				ctx.fill()
				ctx.restore()
				ctx.save()
				// 绘制第四条线
				ctx.beginPath()
				var grd = ctx.createLinearGradient(w / 5 * 3.1, h / 3 * 1.2, w / 5 * 3.2, h / 2 * 1.5);
				grd.addColorStop(0, "#e08d03");
				grd.addColorStop(1, "#2e6a5c");
				ctx.strokeStyle = grd;
				ctx.moveTo(w / 5 * 3.2, h / 2 * 1.5)
				ctx.quadraticCurveTo(w / 5 * 3.35, h / 2 * 1.2, w / 5 * 3.1, h / 3 * 1.2);
				ctx.stroke();
				// 绘制第四条曲线上的圆光效果
				ctx.beginPath()
				ctx.moveTo(w / 5 * 3.1, h / 3 * 1.2)
				ctx.arc(w / 5 * 3.1, h / 3 * 1.2, 5, 0, Math.PI * 2)
				ctx.fill()
				ctx.restore()
				ctx.save()
				// 绘制第五条线
				ctx.beginPath()
				var grd = ctx.createLinearGradient(w / 5 * 3.3, h / 4, w / 5 * 3.2, h / 2 * 1.9);
				grd.addColorStop(0, "#e08d03");
				grd.addColorStop(1, "#2e6a5c");
				ctx.strokeStyle = grd;
				ctx.moveTo(w / 5 * 3.03, h / 2 * 1.9)
				ctx.quadraticCurveTo(w / 5 * 3.8, h / 2 * 1.2, w / 5 * 3.3, h / 4);
				ctx.stroke();
				// 绘制第五条曲线上的圆光效果
				ctx.beginPath()
				ctx.moveTo(w / 5 * 3.3, h / 4)
				ctx.arc(w / 5 * 3.3, h / 4, 5, 0, Math.PI * 2)
				ctx.fill()
				ctx.restore()
				ctx.save()
				// 绘制第六条线
				ctx.beginPath()
				var grd = ctx.createLinearGradient(w / 5 * 3.8, h / 2 * 1.2, w / 5 * 2.9, h);
				grd.addColorStop(0, "#e08d03");
				grd.addColorStop(1, "#2e6a5c");
				ctx.strokeStyle = grd;
				ctx.moveTo(w / 5 * 2.9, h)
				ctx.quadraticCurveTo(w / 5 * 3.7, h / 2 * 1.6, w / 5 * 3.8, h / 2 * 1.2);
				ctx.stroke();
				// 绘制第六条曲线上的圆光效果
				ctx.beginPath()
				ctx.moveTo(w / 5 * 3.8, h / 2 * 1.2)
				ctx.arc(w / 5 * 3.8, h / 2 * 1.2, 5, 0, Math.PI * 2)
				ctx.fill()
			},

			onlink: function() {
				this.$router.go(-1);
			},

			onThermalRunaway: function(value) {
				let str = '';
				if (value == '1') {
					str = '一级告警';
				} else if (value == '2') {
					str = '二级告警';
				} else if (value == '3') {
					str = '三级告警';
				} else {
					str = '正常';
				}
				return str
			},

			onCooling: function(value) {
				let str = '';
				if (value == '1') {
					str = '疑似故障';
				} else if (value == '2') {
					str = '故障';
				} else {
					str = '正常';
				}
				return str;
			}

		},

	}
</script>

<style lang="scss" scoped>
	@import url('../assets/css/index6.css');

	.index6 {
		position: fixed;
		height: 100%;
		width: 100%;
		margin: 0;
		padding: 0;
		overflow: hidden;
		background: url(../assets/images/0330/53bg.png) no-repeat;
		background-size: 100% 100%;


		.main .analyse ul li {
			position: relative;
			border-radius: var(10px);
			transition: all .3s;
			margin-bottom: 5px;

			&::before,
			&::after {
				content: "";
				position: absolute;
				top: -5px;
				left: -5px;
				right: -5px;
				bottom: -5px;
				border: 2px solid #0ac1c7;
				transition: all .5s;
				border-radius: var(10px);
				animation: clippath 3s infinite linear;
			}

			&::after {
				animation: clippath 3s infinite -1.5s linear;
			}

			@keyframes clippath {

				0%,
				100% {
					clip-path: inset(0 0 98% 0);
				}

				25% {
					clip-path: inset(0 98% 0 0);
				}

				50% {
					clip-path: inset(98% 0 0 0);
				}

				75% {
					clip-path: inset(0 0 0 98%);
				}
			}
		}

		.carimg {
			width: 50%;
			height: auto;
			// height: 100px;
			margin-left: 58%;
			position: absolute;
			// animation: mymove 5s 1;
			display: block !important;
			animation-timing-function: linear;
			bottom: -6%;
			z-index: 999;
		}

		@keyframes mymove {

			0% {
				transform: rotateY(160deg);
				left: 7%;
				bottom: -61%;
				width: 100px;
				height: 50px;
			}

			20% {
				transform: rotateY(180deg);
				left: 40%;
				bottom: -69%;
				width: 100px;
				height: 50px;
			}

			30% {
				transform: rotateY(120deg);
				left: 30%;
				bottom: -69%;
				width: 200px;
				height: 66px;
			}

			31% {
				transform: rotateY(70deg);
				left: 33%;
				bottom: -70%;
				width: 213px;
				height: auto;
			}

			35% {
				transform: rotateY(60deg);
				left: 33%;
				bottom: -72%;
				width: 213px;
				// height: auto;
			}

			40% {
				transform: rotateY(40deg);
				left: 33%;
				bottom: -74%;
				width: 213px;
				// height: auto;
			}

			60% {
				transform: rotateY(20deg);
				left: 20%;
				bottom: -84%;
				width: 213px;
				height: auto;
			}

			80% {
				transform: rotateY(0deg);
				left: 10%;
				bottom: -84%;
				width: 213px;
				height: auto;
			}

			100% {
				transform: rotateY(0deg);
				left: 0%;
				bottom: -84%;
				width: 213px;
				height: auto;
			}
		}

		@media screen and (max-width:1024px) {
			.analyse {
				width: 30%;
			}

			.top5 {
				width: 25%;
				position: absolute;
			}

			.total {
				position: absolute;
				left: 0;
				right: 0;
				margin: auto;
			}

			.carimg {
				bottom: -50%;
			}

		}

	}
</style>